import React, { Suspense } from "react";
import { Navigate, Outlet } from "react-router-dom";
import BasicLayout from "../AdminLayout";
import { Flex, Spin } from "antd";
import ErrorBoundary from "antd/es/alert/ErrorBoundary";
import { LoadingOutlined } from "@ant-design/icons";
import { getLocalStorageItem } from "../utils";

function PrivateAuth(props) {
  const isAuthenticated = () => {
    const user = getLocalStorageItem("token_vendor") ? true : false;
    // const user = false;
    return user;
  };

  return isAuthenticated() ? (
    <>
      <BasicLayout>
        <ErrorBoundary>
          <Suspense
            fallback={
              <div className="flex justify-center items-center h-screen">
                <Flex align="center" gap="middle">
                  <Spin
                    style={{}}
                    indicator={
                      <LoadingOutlined
                        style={{
                          fontSize: 78,
                          color: "#6a11cb",
                        }}
                        spin
                      />
                    }
                  />
                </Flex>
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </ErrorBoundary>
      </BasicLayout>
    </>
  ) : (
    <Navigate to="/" replace />
  );
}
export default PrivateAuth;
